import React from 'react'
import Redux from 'app/interface/redux'
import Connect from 'app/redux/connect'
import Basic from 'app/redux/actions/pages/business/basic'
import { User } from '@marketing-milk/interfaces'
import BusinessAuthorizer from './businessAuthorizer'
import { useFeatureFlagEnabled } from 'posthog-js/react'

function formatAdsCustomerID(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 10)
  if (digits.length <= 3) return digits
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
}

const Google = (props: Redux) => {
  const { main } = props.pages.business
  const googleAuthEnabled = useFeatureFlagEnabled('google-auth')
  console.log('auth ff: ', googleAuthEnabled)

  return (
    <div className="m-form m-form--fit mb-5 mx-3">
      <div className="m-form__section">
        <div className="m-form__heading px-4 pt-3 pb-2">
          <h3 className="m-form__heading-title">Google</h3>
        </div>
        <div className="row px-4 pb-4">
          {googleAuthEnabled && (
            <div className="col-md-6 col-sm-12 col-xs-12">
              <BusinessAuthorizer
                title={'Google Authorizer'}
                business={props.pages.business}
                authorizerID={main.google_authorizer_id}
                assignAuthorizer={(authorizer: User) =>
                  Basic.update('google_authorizer_id', authorizer.id)
                }
                filterFn={u => u.googleConnected}
                popover={'This user must have their Google account linked under User Preferences'}
              />
            </div>
          )}
          <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="d-flex flex-column align-items-start px-2 py-2">
              <span className="pb-2">Looker Embed URL</span>
              <input
                className="form-control m-input w-100"
                value={main.google_looker_embed_url || ''}
                onChange={e => Basic.update('google_looker_embed_url', e.target.value)}
              />
            </div>
          </div>
          {googleAuthEnabled && (
            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="d-flex flex-column align-items-start px-2 py-2">
                <span className="pb-2">Google Ads Customer ID</span>
                <input
                  className="form-control m-input w-100"
                  placeholder="000-000-0000"
                  value={formatAdsCustomerID(main.google_ads_customer_id || '')}
                  onChange={e =>
                    Basic.update('google_ads_customer_id', e.target.value.replace(/\D/g, ''))
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Connect(Google)
